import React from "react";
import { TriangleAlert } from "lucide-react";
import { sourceNotes } from "../features/domain-event.utils";

// Warns, before saving, when the picked source can't serve the event yet.
export default function SourceNotice({ source }) {
  const notes = sourceNotes(source);
  if (!notes.length) return null;
  return (
    <div className="flex items-start gap-2 rounded-lg border border-warning_border bg-warning_bg px-3 py-2">
      <TriangleAlert size={14} className="mt-px shrink-0 text-warning" aria-hidden="true" />
      <div className="space-y-0.5 text-xs text-text_primary">
        {notes.map((note) => (
          <p key={note}>{note}</p>
        ))}
      </div>
    </div>
  );
}
